// extracted by mini-css-extract-plugin
export var container = "_ij-0";